import React from "react";
import styled from "styled-components";
import closeIcon from "./images/close-icon.svg";
import BANNER_CONTENT from "./BannerContent";
import { CaptionStyle } from "../Typography";

const Banner = styled.div`
  display: ${props => (props.isVisible ? "flex" : "none")};
  transition: height 0.2s ease-out;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.green2};
  text-align: left;
  height: ${props => (props.isVisible ? "60px" : "0")};
  justify-content: center;
  text-align: center;
  ${({ theme }) => theme.media.tabletUp`
    height: ${props => (props.isVisible ? "41px" : "0")};
  `};
`;

const BannerContent = styled.div`
  display: flex;
  flex: 1;
  margin: auto 8px;
  flex-direction: column;
  text-align: center;
  ${({ theme }) => theme.media.tabletUp`
    flex-direction: row;
    justify-content: center;
  `};
`;

const BannerText = styled.span`
  ${CaptionStyle};
  color: ${({ theme }) => theme.colors.green5};
  line-height: 120%;
  text-align: center;
  margin: auto 8px;
  ${({ theme }) => theme.media.tabletUp`
    line-height: 100%;
    text-align: left;
    margin: auto 8px;
  `};
`;

const BannerLink = styled.a`
  ${CaptionStyle};
  color: ${({ theme }) => theme.colors.green5};
  margin: auto 4px;
  line-height: 100%;
  font-weight: 500;
  &:hover,
  &:active {
    cursor: pointer;
    text-decoration: underline;
  }
`;

const DismissButton = styled.img`
  background-color: transparent;
  border: none;
  &:hover,
  &:active {
    cursor: pointer;
  }
  position: absolute;
  top: 22px;
  right: 22px;
  ${({ theme }) => theme.media.tabletUp`
    top: 10px;
  `};
`;

export default class HiddenBanner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: true
    };
  }

  // Show banner unless sessionStorage and/or cookie dismissal method is present
  componentDidMount() {
    // Gatsby is very opinionated about document objects references and
    // will only process them correctly inside a "componentDidMount" callback!
    // if (typeof window !== "undefined") {
    //   this.setState({
    //     isVisible:
    //       !document.cookie.includes("hide_viz_banner") ||
    //       !window.sessionStorage.getItem("hide_viz_banner")
    //   });
    // }
  }

  // 'x' button handler - soft dismissal via browser session storage
  toggleVisibilty() {
    const { isVisible } = this.state;
    // mimics cookie behavior of its middleman counterpart
    if (typeof window !== "undefined") {
      window.sessionStorage.setItem("hide_viz_banner", true);
    }
    this.setState({ isVisible: !isVisible });
  }

  // Link click handler - rewards link clicks with more permanent cookie-based dismissal of banner
  dismissVisibilty() {
    const { isVisible } = this.state;
    // mimics cookie behavior of its middleman counterpart
    if (typeof document !== "undefined") {
      document.cookie = "hide_viz_banner=true; path=/";
    }
    this.setState({ isVisible: !isVisible });
  }

  render() {
    const { hideMarketingBanner } = this.props;
    const { isVisible } = this.state || !hideMarketingBanner;
    const bannerContent = BANNER_CONTENT;

    return (
      <Banner isVisible={isVisible && !hideMarketingBanner}>
        <BannerContent>
          <BannerText>{bannerContent.subtitle}</BannerText>
          <BannerLink
            href={bannerContent.to}
            target="_blank"
            onClick={() => {
              this.toggleVisibilty();
            }}
          >
            {bannerContent.linkText}
          </BannerLink>
        </BannerContent>
        <DismissButton
          src={closeIcon}
          onClick={() => {
            this.toggleVisibilty();
          }}
        />
      </Banner>
    );
  }
}
